// src/utils/helper.js
import dayjs from 'dayjs';
import moment from 'moment';

/**
 * Convert UTC string to IST formatted string
 * @param {string} utc - ISO string like "2025-08-26T03:03:20.000000Z"
 * @returns {string} e.g. "26 Aug 2025, 08:33 AM IST"
 */
export const formatToIST = (utc) => {
  if (!utc) return '—';

  const utcMoment = moment.utc(utc);
  const istMoment = utcMoment.clone().add(5, 'hours').add(30, 'minutes');

  return `${istMoment.format('DD MMM YYYY, hh:mm A')} IST`;
};

export const formatDate = (value, format = 'DD MMM YYYY') => {
  if (!value) return '—';

  const parsed = dayjs(value);
  if (!parsed.isValid()) return '—';

  return parsed.format(format);
};

export const getInspectionExpiryStatus = (expiryDate, warningWindowDays = 30) => {
  if (!expiryDate) {
    return {
      label: 'Not Set',
      color: 'default',
      daysRemaining: null
    };
  }

  const parsed = dayjs(expiryDate);
  if (!parsed.isValid()) {
    return {
      label: 'Invalid Date',
      color: 'default',
      daysRemaining: null
    };
  }

  const today = dayjs().startOf('day');
  const expiry = parsed.startOf('day');
  const daysRemaining = expiry.diff(today, 'day');

  if (daysRemaining < 0) {
    return {
      label: 'Expired',
      color: 'error',
      daysRemaining
    };
  }

  if (daysRemaining <= warningWindowDays) {
    return {
      label: 'Expiring Soon',
      color: 'warning',
      daysRemaining
    };
  }

  return {
    label: 'Active',
    color: 'success',
    daysRemaining
  };
};
